import { Typography } from "@stardust-ds/react";
import Input from "../../atoms/Input";
import Select from "../../atoms/Select";
import RcmpDatePicker from "../../atoms/DatePicker";
import RcmpFormErrorMessage from "../../atoms/FormErrorMessage";
import RcmpCheckBox from "../../atoms/Checkbox";
import RcmpTooltip from "../../atoms/Tooltip";
import RcmpTimePicker from "../../atoms/TimePicker";
import intl, { get } from 'react-intl-universal'

import styles from "./index.module.scss";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { fnFormatDate } from "../../../utils/date";

export default function RcmpTiggerRecurrence(props) {
    const { setValue, errors, getValues, watch, cUserTimezone, bDeadLineIsRequired, aBlocks, fnSetBIsDisabledButton, fnSetOblockSelected, nStep, setError, clearErrors, bIsEditAutomation } = props;
    const aOptionTimeRange = [
        {
            label: intl.get("modal_new_form.minutes"),
            value: "minute",
        },
        {
            label: intl.get("modal_new_form.hour"),
            value: "hour",
        },
        {
            label: intl.get("modal_new_form.day"),
            value: "day",
        },
        {
            label: intl.get("modal_new_form.week"),
            value: "week",
        },
        {
            label: intl.get("modal_new_form.month"),
            value: "month",
        },

    ]
    const [oBlocksOptions, fnSetOBlocksOptions] = useState([])
    const [oSelectTimeRanger, fnSetOSelectTimeRanger] = useState({})
    const [bHasDeadLine, fnSetBHasDeadLine] = useState(!getValues("notDeadLine"))
    const [nRepeatAtValue, fnSetNRepeatAtValue] = useState(getValues("repeatAt") || 15)
    const [bAllFilled, fnSetBAllFilled] = useState(true)
    const aOptionTimeRangeDeadLine = aOptionTimeRange.slice(1)
    const repeatAtRef = useRef(null)
    const aOptionRecurrence = [
        {
            label: intl.get("modal_new_automation.days_of_weeks.monday"),
            value: 2,
            checked: false
        },
        {
            label: intl.get("modal_new_automation.days_of_weeks.tuesday"),
            value: 3,
            checked: false
        },
        {
            label: intl.get("modal_new_automation.days_of_weeks.wednesday"),
            value: 4,
            checked: false
        },
        {
            label: intl.get("modal_new_automation.days_of_weeks.thursday"),
            value: 5,
            checked: false
        },
        {
            label: intl.get("modal_new_automation.days_of_weeks.friday"),
            value: 6,
            checked: false
        },
        {
            label: intl.get("modal_new_automation.days_of_weeks.saturday"),
            value: 7,
            checked: false
        },
        {
            label: intl.get("modal_new_automation.days_of_weeks.sunday"),
            value: 1,
            checked: false
        },
    ]
    let aWeekInitialValue = !getValues("daysOfWeekRecurrence")?.length && getValues("repeatRange") !== "week" ? aOptionRecurrence : aOptionRecurrence?.map(option => {
        if (getValues("daysOfWeekRecurrence").includes(option.value) || getValues("daysOfWeekRecurrence").some(day => day === option.value)) {
            return {
                ...option,
                checked: true
            }
        }
        return option
    })
    const [aSelectedDays, fnSetAaSelectedDays] = useState(aWeekInitialValue)


    useEffect(() => {
        const oBlockOptions = aBlocks?.map((block) => ({
            label: block.opbl_cname,
            value: block.opbl_nid,
        }))

        fnSetOBlocksOptions(oBlockOptions)
    }, [aBlocks])

    // useEffect(() => {
       
    //     setValue("beginDate", "")
    //     setValue("beginTime", "")
    // }, [bIsEditAutomation])
    useEffect(() => {
        if (nStep !== 1) return
        const bValidate = (getValues("repeatRange") === undefined || getValues("monthDay") === undefined || getValues("deadLineRange") === undefined || getValues("repeatAt") === null || getValues("repeatAt") <= 0 || !getValues("beginDate") || !getValues("beginTime") || !getValues("blockId") || (getValues("repeatRange").value === "week" && getValues("daysOfWeekRecurrence")?.length === 0) || (getValues("repeatRange")?.value === "minute" && getValues("repeatAt") < 15) || (getValues("repeatRange")?.value === "month" && getValues("repeatAt") > 12))

        if (getValues("repeatRange")?.value === "minute" && getValues("repeatAt") < 15) {
            setError("repeatAt", { type: "manual", message: intl.get("modal_new_automation.repeat_at_lower_minute") })
            fnSetBIsDisabledButton(true)
        }else if (getValues("repeatRange")?.value === "month" && getValues("repeatAt") > 12) {
            
            setError("repeatAt", { type: "manual", message: intl.get("modal_new_automation.repeat_at_lower_month") })
            fnSetBIsDisabledButton(true)
        }else {
            clearErrors("repeatAt")
        }

        if (bValidate) {
            fnSetBIsDisabledButton(true)
        } else {
            fnSetBIsDisabledButton(false)
        }

    }, [watch("repeatRange"), watch("monthDay"), watch("deadLineRange"), watch("repeatAt"), watch("beginDate"), watch("beginTime"), watch("blockId"), watch("daysOfWeekRecurrence")])


    function fnSelectedBlock(e) {
        fnSetOblockSelected(e)
        setValue("blockId", e)
    }
    function fnSelectDay(e, i) {
        const aDaysOfWeekCopy = [...aSelectedDays]
        const oUpdateValue = {
            ...aSelectedDays[i],
            checked: e.target.checked
        }
        aDaysOfWeekCopy.splice(i, 1, oUpdateValue)
        fnSetAaSelectedDays(aDaysOfWeekCopy)
        const dDaysChecked = aDaysOfWeekCopy.filter(day => day.checked).map(day => day.value)
        setValue("daysOfWeekRecurrence", dDaysChecked)
    }

    function fnSelectDeadLineRange(e) {
        if (!e) {
            fnSetBAllFilled(false)
            setValue("deadLineRange", undefined)
            return
        }
        fnSetBAllFilled(true)
        fnSetBIsDisabledButton(false)
        setValue("deadLineRange", e)
    }

    function fnHandleDeadLine(e) {
        fnSetBHasDeadLine(!e.target.checked)
        setValue("notDeadLine", e.target.checked)
    }

    function fnOnSelectTimeRanger(e) {

        fnSetOSelectTimeRanger(e || {})
        const cCurrentDay = moment().tz(cUserTimezone).format("DD")
        if (!e) {
            fnSetBAllFilled(false)
            setValue("repeatRange", undefined)
            return
        }

        if (e.value !== "month") {
            setValue("monthDay", { label: `${cCurrentDay}`, value: cCurrentDay })
        }
        if (e.value !== "week") {
            setValue("daysOfWeekRecurrence", [])
            fnSetAaSelectedDays(aOptionRecurrence)
        }
        fnSetBAllFilled(true)
        fnSetBIsDisabledButton(false)
        setValue("repeatRange", e)
        if (getValues("repeatAt") < 15 && e.value === "minute") {
            setValue("repeatAt", 15)
            fnSetNRepeatAtValue(15)
        }
        if (getValues("repeatAt") > 12 && e.value === "month") {
            setValue("repeatAt", 12)
            fnSetNRepeatAtValue(12)
        }
        return
    }
    function fnHandleReatAtValue(e) {
        setValue("repeatAt", Number(e))
        fnSetNRepeatAtValue(Number(e))
    }
    return (
        <div className={styles.thirdStepContainer}>
            <p>{intl.get("modal_new_automation.automation_recurrence")}</p>
            <div className={styles.contentModal}>
                <div className={styles.settingRecurrence}>
                    <Typography className={styles.timeRangeLabel} type="p2" color="#415364">{intl.get("modal_new_automation.repeat_each")}</Typography>
                    <Input ref={repeatAtRef} className={styles.numberInputRepeat} type="number" min={"1"} max="999" defaultValue={Number(nRepeatAtValue)} value={nRepeatAtValue} onChange={(e) => fnHandleReatAtValue(e)} />

                    <Select className={styles.timeRangeSelect} width={"113px"} options={aOptionTimeRange} defaultValue={getValues("repeatRange") || aOptionTimeRange[0]} onSelect={(e) => fnOnSelectTimeRanger(e)} />

                </div>
                <div className={styles.errorMessageArea}>
                    <RcmpFormErrorMessage>{errors.repeatAt?.message}</RcmpFormErrorMessage>
                </div>
                <div className={styles.datePickerSelect}>
                    <Typography type="p2" color="#415364">{intl.get("modal_new_automation.start_date")}</Typography>
                    <RcmpDatePicker
                        className={styles.datePicker}
                        bTime={false}
                        defaultValue={getValues("beginDate") || ""}
                        onChange={(e) => {
                            setValue("beginDate", fnFormatDate(e, "YYYY-MM-DD", false, cUserTimezone, "YYYY-MM-DD HH:mm"))
                        }}
                    />
                    <Typography type="p2" color="#415364">{intl.get("modal_new_automation.starting_from")}</Typography>
                    <RcmpTimePicker className={styles.timePicker} onChange={e => setValue("beginTime", e)} defaultValue={getValues("beginTime")} />
                </div>
                <div className={styles.errorMessageArea}>
                    <RcmpFormErrorMessage>{errors.beginDate?.message}</RcmpFormErrorMessage>
                    <RcmpFormErrorMessage>{errors.beginTime?.message}</RcmpFormErrorMessage>
                </div>
                {oSelectTimeRanger.value === "week" &&
                    <>
                        <p style={{ marginBottom: "-16px" }}>{intl.get("modal_new_automation.week_recurrence")}</p>
                        <div className={styles.daysOfWeekContainer}>
                            {aSelectedDays?.map((day, i) => {
                                return (
                                    <div className={styles.checkboxArea} key={i}>
                                        <RcmpCheckBox onChange={e => fnSelectDay(e, i)} checked={day.checked} />
                                        <Typography type="p2" color="#415364">{day.label} </Typography>
                                    </div>
                                )
                            })}
                        </div>
                    </>}
                <div className={styles.footer}>
                    <div className={styles.footerTextInfo}>
                        <p >{intl.get("modal_new_automation.deadline_execution")}</p>
                        <RcmpTooltip bOnHover={true}>
                            {intl.get("modal_new_automation.info_deadline")}
                        </RcmpTooltip>
                    </div>
                    <div className={styles.footerSetting}>
                        <Input disabled={!bHasDeadLine} className={styles.deadlineNumberArea} type="number" min="1" max="999" onChange={(e) => setValue("deadLineValue", e)} defaultValue={getValues("deadLineValue") || 1} />
                        <Select disabled={!bHasDeadLine} className={styles.timeRangeSelect} width={"155px"} options={aOptionTimeRangeDeadLine} defaultValue={getValues("deadLineRange") || aOptionTimeRangeDeadLine[0]} onSelect={(e) => fnSelectDeadLineRange(e)} />
                    </div>
                    <div className={styles.checkboxArea}>
                        <RcmpCheckBox disabled={bDeadLineIsRequired} cLabel={intl.get("modal_new_automation.without_deadline")} checked={getValues("notDeadLine")} onChange={(e) => fnHandleDeadLine(e)} />
                    </div>
                    <div className={styles.selectBlockArea}>
                        <Select options={oBlocksOptions} onSelect={fnSelectedBlock} label={`${intl.get("modal_new_automation.create_activity_block")}*`} defaultValue={getValues("blockId") || ""} />
                        {errors.blockId?.message && <RcmpFormErrorMessage>{errors.blockId?.message}</RcmpFormErrorMessage>}
                    </div>
                </div>
            </div>
        </div>
    )
}